import styles from './styles.module.scss';
import { useGamesBySlugWithQueryParams } from '@/hooks/games/useGamesBySlugWithQueryParams';
import { platformAssets } from '@/utils/assets';
import { ErrorCard, TransWithDefault } from '@starsoft/common/components';

export default function GameDetailsContentDescription() {
  const { game, isLoading, refetch, error } = useGamesBySlugWithQueryParams();

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  if (isLoading) {
    return (
      <div className={styles.skeleton__container}>
        <div className={styles.skeleton__text} />
        <div className={styles.skeleton__text} />
        <div className={styles['skeleton__text--half']} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <TransWithDefault
        i18nKey={`game-tag:${game?.tags?.[0]?.tag?.id}.description`}
        values={{
          app_provider: platformAssets.app,
          game: game?.name,
          provider: game?.provider?.name,
          game_provider: game?.provider?.name,
        }}
      />
    </div>
  );
}
